import { useState, useEffect } from 'react';

const getOnlineStatus = (): boolean =>
  typeof navigator !== 'undefined' && typeof navigator.onLine === 'boolean'
    ? navigator.onLine
    : true;

export const useOnline = (): { isOnline: boolean } => {
  const [isOnline, setIsOnline] = useState(getOnlineStatus());

  useEffect(() => {
    window.addEventListener('online', () => setIsOnline(true), false);
    window.addEventListener('offline', () => setIsOnline(false), false);
    return () => {
      window.removeEventListener('online', () => setIsOnline(true), false);
      window.removeEventListener('offline', () => setIsOnline(false), false);
    };
  }, []);

  return { isOnline };
};
